import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateProgramTimer = (props) => {
  return (
    <Create
// @ts-ignore
      title='Add Program Timer'
      fields={fields}
      apiPath='admin/program_timer_types'
      successRedirectPath={resource => `/write-now/program_timers/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateProgramTimer
